module.exports = __webpack_public_path__ + "img/8.860dd45e.jpg";